import { Injectable } from '@angular/core';
import { DatabaseService } from '../alcance/services/database.service';

@Injectable({
  providedIn: 'root'
})
export class TipoMotivoDBService extends DatabaseService {
    override classname: string = 'TipoMotivoDBService';
    override table = 'tipo_motivo';

    override indices = [
        { name: "by_id", field: "id", unique: true, multiEntry: false },
        { name: "by_descricao", field: "descricao", unique: false, multiEntry: false },
    ];
}

